import React from 'react';

const ScreenRecordingInstructions = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <div className="font-l5 font-l5--regular color-white">
                Hit &quot;Start Recording,&quot; then choose the screen you want to record.
            </div>
        </div>
    );
};
export default React.memo(ScreenRecordingInstructions);
